import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SchoolType } from "../types";

export interface Event {
  id: string;
  title: string;
  date: string;
  school: SchoolType;
}

interface EventState {
  all: Event[];
  lyceeFrancais: Event[];
  lyceeIvoirien: Event[];
  institut: Event[];
  maternellePrimaire: Event[];
}

const initialState: EventState = {
  all: [],
  lyceeFrancais: [],
  lyceeIvoirien: [],
  institut: [],
  maternellePrimaire: []
};

const getKey = (school: SchoolType): keyof EventState => {
  return school === "all" ? "all" : school;
};

export const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setAllEvents(state, action: PayloadAction<Event[]>) {
      state.all = action.payload;
    },
    setEventsBySchool(
      state,
      action: PayloadAction<{ school: SchoolType; data: Event[] }>
    ) {
      state[getKey(action.payload.school)] = action.payload.data;
    }
  }
});

export const { setAllEvents, setEventsBySchool } = eventSlice.actions;
export default eventSlice.reducer;
